import { differenceInYears, differenceInMonths, differenceInDays, differenceInHours, differenceInMinutes } from 'date-fns';

const pluralize = (value, unit) => {
    return `${value} ${unit}${value > 1 ? 's' : ''}`;
};

const startedDate = (createdAt) => {
    if (!createdAt) return '-';

    const start = new Date(createdAt);
    const now = new Date();

    let years = differenceInYears(now, start);
    let tempDate = new Date(start);
    tempDate.setFullYear(tempDate.getFullYear() + years);

    let months = differenceInMonths(now, tempDate);
    tempDate.setMonth(tempDate.getMonth() + months);

    let days = differenceInDays(now, tempDate);
    tempDate.setDate(tempDate.getDate() + days);

    let hours = differenceInHours(now, tempDate);
    tempDate.setHours(tempDate.getHours() + hours);

    let minutes = differenceInMinutes(now, tempDate);

    let result = '';

    if (years > 0) {
        result = pluralize(years, 'year');
        if (months > 0) result += `, ${pluralize(months, 'month')}`;
    } else if (months > 0) {
        result = pluralize(months, 'month');
        if (days > 0) result += `, ${pluralize(days, 'day')}`;
    } else if (days > 0) {
        result = pluralize(days, 'day');
        if (hours > 0) result += `, ${pluralize(hours, 'hour')}`;
    } else if (hours > 0) {
        result = pluralize(hours, 'hour');
        if (minutes > 0) result += `, ${pluralize(minutes, 'minute')}`;
    } else {
        result = pluralize(minutes, 'minute');
    }

    return result + ' ago';
};

export default startedDate;
